<template>
  <div class="freight-route-rules">
    <div class="top-box">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="线路类型:" prop="lineType">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.lineType"
                  filterable
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in $dict.lineTypeOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="出发城市网格:">
                <custom-city-cascader
                  :province-code="searchForm.startProvinceCode"
                  :city-code="searchForm.startCityCode"
                  :district-code="searchForm.startDistrictCode"
                  @update:provinceCode="
                    (val) => (searchForm.startProvinceCode = val)
                  "
                  @update:cityCode="(val) => (searchForm.startCityCode = val)"
                  @update:districtCode="
                    (val) => (searchForm.startDistrictCode = val)
                  "></custom-city-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="到达城市网格:">
                <custom-city-cascader
                  :province-code="searchForm.endProvinceCode"
                  :city-code="searchForm.endCityCode"
                  :district-code="searchForm.endDistrictCode"
                  @update:provinceCode="
                    (val) => (searchForm.endProvinceCode = val)
                  "
                  @update:cityCode="(val) => (searchForm.endCityCode = val)"
                  @update:districtCode="
                    (val) => (searchForm.endDistrictCode = val)
                  "></custom-city-cascader>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="">
                <div style="display: flex">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset()" ></el-button>
                <el-button type="primary" @click="handleAdd()">新增计费线路</el-button>
                <el-upload
                  style="margin: 0 10px"
                  ref="upload"
                  action=""
                  :show-file-list="false"
                  :http-request="handleChange"
                  :before-upload="beforeAvatarUpload"
                  :limit="1"
                >
                  <slot>
                    <el-button type="primary" @click="handleUpload()" :loading="uploadLoading">计费线路导入</el-button>
                  </slot>
                </el-upload>
                <el-button type="text"  @click="handleDownloadTemplate" :loading="downloadLoading">下载导入模板</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <div class="warning-box">
        <div class="custom-tip">
          <el-image :src="require('@/assets/imgs/price-tip.png')" class="tip-img"></el-image>
          <div class="tip-box">
            <div class="tip-title">
              <span>订单价格计算说明</span>
            </div>
            <div class="tip-list">
              （1）0-0.3t及0.3-0.5t的订单，根据线路直接收取线路中重量对应价格，即0-0.3t及0.3-0.5t根据线路按票收费
            </div>
            <div class="tip-list">
              （2）0.5t以上的订单按线路重量区间的价格*重量（t）进行计算，计算结果小于保底价的订单金额按保底价算，其中0.5t-1t的保底价为0.3-0.5t的价格、1-1.5t的保底价为0.5-1t的价格、1.5-2t的保底价为1-1.5t的价格*1.5、
              1.5-2t的保底价为1-1.5t的价格*1.5、2-3t的保底价为1.5-2t的价格*2
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:lineType="{ row }">
          {{ getLocalLabel("lineType", row.lineType) }}
        </template>
        <template v-slot:price="{ row }">￥{{ row.price }}</template>
        <template v-slot:operation="{ row }">
          <span class="operate-btn" @click="handleEdit(row)">编辑</span>
          <span class="operate-btn" @click="handleDelete(row.pricingId)">删除</span>
        </template>
      </custom-table>
    </div>
    <add-or-edit ref="addOrEdit"></add-or-edit>
    <info-dialog ref="infoDialog"></info-dialog>
  </div>
</template>
<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import { getPage, deleteInfo, downloadTemplate, importPricing } from "../api";
import tableMixin from "@/mixin/tableMixin";
import addOrEdit from "../addOrEdit.vue";
import infoDialog from "./infoDialog.vue";
import CustomCityCascader from "@/components/CustomCityCascader.vue";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import { getLocalLabel } from "@/utils/localDict";
import { blobToText, downloadFileCustom } from "@/utils/tool";
export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    infoDialog,
    addOrEdit,
    CustomTabBox,
    CustomCityCascader,
    OperateBox,
    CustomTable,
    CustomDateRange,
  },
  data() {
    return {
      downloadLoading: false,
      uploadLoading: false,
      getTableMethod: getPage,
      deleteMethod: deleteInfo,
      searchForm: {
        endCityCode: "",
        endDistrictCode: "",
        endProvinceCode: "",
        lineType: "",
        startCityCode: "",
        startDistrictCode: "",
        startProvinceCode: "",
      },
      isImmediatelyGetData: true,
      tableColumn: [
        {
          label: "线路类型",
          prop: "lineType",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "出发城市",
          prop: "startCityName",
          align: "left",
          show: true,
        },
        {
          label: "出发网格",
          prop: "startDistrictName",
          align: "left",
          show: true,
        },
        {
          label: "到达城市",
          prop: "endCityName",
          align: "left",
          show: true,
        },
        {
          label: "到达网格",
          prop: "endDistrictName",
          align: "left",
          show: true,
        },
        {
          label: "0-0.3t(含)",
          prop: "price1",
          align: "left",
          show: true,
          width: "150"
        },
        {
          label: "0.3-0.5t(含)",
          prop: "price2",
          align: "left",
          show: true,
          width: "150"
        },
        {
          label: "0.5-1t(含)",
          prop: "price3",
          align: "left",
          show: true,
          width: "150"
        },
        {
          label: "1-1.5t(含)",
          prop: "price4",
          align: "left",
          show: true,
          width: "150"
        },
        {
          label: "1.5-2t(含)",
          prop: "price5",
          align: "left",
          show: true,
          width: "150"
        },
        {
          label: "2-3t(含)",
          prop: "price6",
          align: "left",
          show: true,
          width: "150"
        },
        {
          label: "3t以上",
          prop: "price7",
          align: "left",
          show: true,
          width: "150"
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "130",
          scopeStatus: true,
          show: true,
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleUpload() {},
    // 图片上传之前的
    beforeAvatarUpload(file) {
      return true;
    },
    handleChange(file, fileList) {
      this.uploadFiles(file);
    },
    uploadFiles(file) {
      // // console.log("file", file);
      let files = file.file;
      let formData = new FormData();
      formData.append("file", files);
      this.uploadLoading = true;
      importPricing(formData)
        .then((res) => {
          this.uploadLoading = false;
          this.$refs.upload.clearFiles()
          if (res.code === 200) {
            // // console.log("11111111111", res.data);
            this.tableOptions.currentPage = 1;
            this.getTableData()
            this.$refs.infoDialog.init(res.data);
          }
        })
        .catch((err) => {
          this.uploadLoading = false;
          this.$refs.upload.clearFiles()
        });
    },
    handleDownloadTemplate() {
      this.downloadLoading = true;
      downloadTemplate()
        .then((res) => {
          this.downloadLoading = false;

          blobToText(res.data).then((data) => {
            // // // console.log("data", data);
            downloadFileCustom(data, "计价规则模板.xlsx");
          });
        })
        .catch(() => {
          this.downloadLoading = false;
        });
    },
    getTableData() {
      let params = {
        currentPage: this.tableOptions.currentPage,
        pageSize: this.tableOptions.pageSize,
        param: { ...this.searchForm },
      };
      // // console.log("传参----", params);
      this.tableOptions.loading = true;
      this.getTableMethod(params)
          .then((res) => {
            this.tableOptions.loading = false;
            if (res.code === 200) {
              if (
                  this.tableOptions.currentPage > 1 &&
                  (res.data === undefined || res.data.data.length === 0)
              ) {
                this.tableOptions.currentPage--;
                this.getTableData();
                return;
              }
              if (res.data.data && res.data.data.length > 0) {
                res.data.data.forEach((item) => {
                  item.loading = false;
                });
              }
              // // console.log("res.data", res.data);
              if (res.data.data && res.data.data.length > 0) {
                res.data.data.forEach((item) => {
                  item.price1 = item.rules[0].price + "元";
                  item.price2 = item.rules[1].price + "元";
                  item.price3 = item.rules[2].price + "元";
                  item.price4 = item.rules[3].price + "元";
                  item.price5 = item.rules[4].price + "元";
                  item.price6 = item.rules[5].price + "元";
                  item.price7 = item.rules[6].price + "元";
                });
              }
              this.tableData = res.data.data;
              this.tableOptions.total = res.data.totalCount;
              this.tableOptions.pageCount = res.data.totalPage;
            }
          })
          .catch(() => {
            this.tableOptions.loading = false;
          });
    },
    getLocalLabel,
    openDetail(row) {
      this.$refs.detail.init(row);
    },
  },
};
</script>
<style lang="scss" scoped>
.freight-route-rules {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .custom-tip {
    font-size: 0.16rem;
    padding: 0.16rem 0.2rem;
    background: rgba(18, 105, 255, 0.05);
    box-sizing: border-box;
    margin: 0 0.16rem;
    border-radius: 0.03rem;
    border: 0.01rem dashed #1269ff;
    display: flex;
    align-items: center;
    .tip-img {
      width: 0.44rem;
      height: 0.44rem;
      flex-shrink: 0;
      margin-right: 0.2rem;
    }
    .tip-title {
      display: flex;
      align-items: center;
      padding-bottom: 0.06rem;
      i {
        color: #cf9236;
        margin-right: 0.03rem;
      }
      span {
        color: #000000;
        font-size: 0.14rem;
      }
    }
    .tip-list {
      line-height: 0.26rem;
      box-sizing: border-box;
      font-size: 0.12rem;
      color: #434343;
    }
  }
  .top-box {
    .tab-box {
      padding: 0.2rem 0 0 0.2rem;
    }
  }
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }

  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
  .statistics-box {
    display: flex;
    justify-content: space-around;
    padding: 0 0.16rem;
    margin: 0 -0.1rem;
    .statistics-list {
      width: 33.33%;
      height: 1.2rem;
      background-color: #ffffff;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.2rem;
      box-sizing: border-box;
      margin: 0 0.1rem;
      .statistics-image {
        width: 0.8rem;
        height: 0.61rem;
      }
      .statistics-num {
        .num {
          font-size: 0.24rem;
          color: #000000;
          font-weight: bold;
          text-align: center;
        }

        .txt {
          font-size: 0.14rem;
          color: #434343;
          padding-top: 0.1rem;
          text-align: center;
        }
      }
    }
  }
}
</style>
